import React from 'react'

export const EmptyLayout = (props: { hasWrapper: boolean; text: string }) =>
  props.hasWrapper ? (
    <div className="container--m gutter--m">
      <p className="block__empty-state">{props.text}</p>
    </div>
  ) : (
    <p className="block__empty-state">{props.text}</p>
  )
